import React from "react";
import { Helmet } from "react-helmet-async";

const GA4_ID = process.env.REACT_APP_GA4_ID;
const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION;

// Injects Google Search Console verification + Google Analytics 4 only when
// the corresponding env vars are configured. Safe no-op until you add the codes.
export const Analytics = () => {
  if (!GA4_ID && !GSC_VERIFICATION) return null;
  return (
    <Helmet>
      {GSC_VERIFICATION && <meta name="google-site-verification" content={GSC_VERIFICATION} />}
      {GA4_ID && <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`} />}
      {GA4_ID && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('consent', 'default', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
          });
          try {
            if (localStorage.getItem('ilakeit-cookie-consent') === 'accepted') {
              gtag('consent', 'update', { 'analytics_storage': 'granted' });
            }
          } catch(e){}
          gtag('config', '${GA4_ID}');
        `}</script>
      )}
    </Helmet>
  );
};

export default Analytics;
